import { mapHistoryAction } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/History/utils/mapHistoryAction';
import { HistoryEventResult } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/types';
import { DATE_FORMATS, formatDateToUI } from '@dealstack/shared/lib/format/dates/date';
import { KycEventLogEntity } from '@dealstack/shared/lib/generated';
import { toEventDocument } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/History/HistoryEvents.utils';

export const mapHistoryToEvent = (
	history: KycEventLogEntity[] | undefined
): HistoryEventResult[] | undefined => {
	const historyMapped = history?.map((h) => ({
		action: mapHistoryAction(h.action, h.status),
		actor: `${h.userAction.userSession.user.firstName} ${h.userAction.userSession.user.lastName}`,
		timestamp: formatDateToUI(new Date(h.createdAt), DATE_FORMATS.DATE_TIME_ALT),
		browserInfo: `${h.userAction.userSession.browserName}, ${h.userAction.userSession.browserVersion}, ${h.userAction.userSession.osName}`,
		document: toEventDocument(h.file),
		status: h.status,
		comment: h.comment,
		kycFileId: h.kycFileId ?? null,
	}));
	return historyMapped;
};
